module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.hasPermission()) ? _c('a', {
    staticClass: "ls-btn ls-no-margin ls-float-right",
    staticStyle: {
      "margin-left": "5px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.loadLog($event)
      }
    }
  }, [_vm._v("Visualizar Logs")]) : _vm._e(), _vm._v("\n       \n  "), _c('modal', {
    attrs: {
      "klass": 'ls-modal-large'
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('div', {
    slot: "content"
  }, [_c('div', {
    staticClass: "ls-modal-header"
  }, [_c('button', {
    attrs: {
      "close-modal": "",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "ls-modal-title"
  }, [_vm._v("Log de contrato")])]), _vm._v(" "), _c('div', {
    staticClass: "ls-modal-body"
  }, [_c('table', {
    staticClass: "ls-table"
  }, [_c('thead', [_c('th', [_vm._v("Entidade/Horário")]), _vm._v(" "), _c('th', [_vm._v("Mensagem")]), _vm._v(" "), _c('th', [_vm._v("Autor")])]), _vm._v(" "), _c('tbody', [(_vm.logs.lengt === 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Não existem log")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.logs), function(log) {
    return _c('tr', [_c('td', [_vm._v(" " + _vm._s(log.entity_type) + " (" + _vm._s(log.identifier_id) + ") / " + _vm._s(_vm.parseDate(log.created_at)) + " ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(log.message) + " ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(log.author))])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "ls-modal-footer"
  }, [_c('button', {
    staticClass: "ls-btn pull-right",
    attrs: {
      "close-modal": "",
      "data-dismiss": "modal"
    }
  }, [_vm._v(_vm._s(_vm.$t('application.button.close')))])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59e2b800"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/contracts/components/ModalLog.vue
// module id = 784
// module chunks = 1